/**
 * @file Web Gallery discovery container.
 */

import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import WebGalleryDiscovery from '../components/WebGalleryDiscovery';

export default compose(withRouter)(WebGalleryDiscovery);
